import Enum from 'enum'

export const SortConversationsEnum = new Enum({
  'NEWEST': 'newest',
  'OLDEST': 'oldest',
})



// WEBPACK FOOTER //
// ./src/scripts/constants/SortConversationsConstants.js